/** 转换ASCII (十六进制数组) 为字符串 */
export function convertASCIIToStr(array: string[], encoding: string = 'utf-8') {
  const byteArray: number[] = []
  for (let i = 0; i < array.length; i++) {
    const value = parseInt(array[i], 16)
    if (value !== 0) {
      byteArray.push(value)
    }
  }
  try {
    const decoder = new TextDecoder(encoding)
    return decoder.decode(new Uint8Array(byteArray))
  } catch (e) {
    console.error('Failed to decode string:', e)
    return ''
  }
}

/** 转换字符串为ASCII语言 */
export function convertStrToASCII(str: string) {
  const encoder = new TextEncoder()
  const bytes = encoder.encode(str)
  return Array.from(bytes)
}

/**
 * 从 Uint8Array 中提取空终止的 UTF-8 字符串。
 * 从 0 开始截取到第一个 0x00 或末尾。
 */
export function extractPayloadString(data: Uint8Array): string {
  let end = data.length
  for (let i = 0; i < data.length; i++) {
    if (data[i] === 0) {
      end = i
      break
    }
  }
  return new TextDecoder().decode(data.slice(0, end))
}

/**
 * 将字符串编码为指定长度的 Uint8Array，尾部 padding 填充 0。
 */
export function encodeStringToBytes(str: string, length: number): Uint8Array {
  const buf = new Uint8Array(length)
  buf.set(convertStrToASCII(str).slice(0, length))
  return buf
}
